{
  "name": "rocc-resolve-client",
  "version": "12.7.0",
  "author": "ROCC",
  "bugs": "https://github.com/ROCC-Housing-Technology/rocc-resolve/issues",
  "homepage": "https://github.com/ROCC-Housing-Technology/rocc-resolve",
  "scripts": {
    "ng": "ng",
    "copy:changelog": "node -e \"require('fs').copyFileSync(require('path').join(__dirname,'..','CHANGELOG.md'),require('path').join(__dirname,'src','CHANGELOG.md'))\"",
    "prestart": "npm run copy:changelog",
    "start": "ng serve --open --verbose",
    "start:server": "dotenv -o -e .env.local -- npm run start:server:run",
    "start:server:run": "node ../scripts/start-server.js",
    "prebuild": "npm run copy:changelog",
    "build": "ng build",
    "test": "ng test",
    "test:ci": "cross-env CI=true NODE_OPTIONS=--max_old_space_size=4096 ng test --configuration=test --browsers=ChromeHeadlessCI --watch=false --code-coverage",
    "lint": "ng lint",
    "watch": "ng test --configuration=test --browsers ChromeHeadless --watch",
    "clean": "rimraf ./dist/",
    "server": "cd dist/browser && http-server  -a localhost -p 4200",
    "prod": "npm run clean && npm run build && npm run server",
    "prettier": "prettier \"src/**/*.{ts,json,scss}\" --write",
    "prettier:ci": "prettier \"src/**/*.{ts,json,scss}\" --list-different",
    "controlflow": "ng generate @angular/core:control-flow",
    "storybook": "ng run uniclass-scheduler:storybook",
    "build-storybook": "ng run uniclass-scheduler:build-storybook"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/schematics": "^21.2.19",
    "@angular/animations": "^21.2.18",
    "@angular/cdk": "^21.2.9",
    "@angular/common": "^21.2.18",
    "@angular/compiler": "^21.2.18",
    "@angular/core": "^21.2.18",
    "@angular/elements": "^21.2.18",
    "@angular/forms": "^21.2.18",
    "@angular/material": "^21.2.9",
    "@angular/material-moment-adapter": "^21.2.9",
    "@angular/platform-browser": "^21.2.18",
    "@angular/platform-browser-dynamic": "^21.2.18",
    "@angular/router": "^21.2.18",
    "@angular/service-worker": "^21.2.18",
    "@angular/upgrade": "^21.2.18",
    "@azure/msal-angular": "5.3.1",
    "@azure/msal-browser": "5.17.1",
    "@bryntum/calendar-thin": "7.3.4",
    "@bryntum/core-angular-thin": "7.3.4",
    "@bryntum/core-thin": "7.3.4",
    "@bryntum/engine-thin": "7.3.4",
    "@bryntum/grid-thin": "7.3.4",
    "@bryntum/scheduler-thin": "7.3.4",
    "@fortawesome/angular-fontawesome": "file:vendor/fortawesome-angular-fontawesome-4.0.0.tgz",
    "@fortawesome/fontawesome-common-types": "file:vendor/fortawesome-fontawesome-common-types-7.2.0.tgz",
    "@fortawesome/fontawesome-pro": "file:vendor/fortawesome-fontawesome-pro-7.2.0.tgz",
    "@fortawesome/fontawesome-svg-core": "file:vendor/fortawesome-fontawesome-svg-core-7.2.0.tgz",
    "@lagoshny/ngx-hateoas-client": "21.0.1",
    "@microsoft/applicationinsights-web": "^3.4.1",
    "@ngrx/effects": "^21.1.1",
    "@ngrx/operators": "^21.1.1",
    "@ngrx/store": "^21.1.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@stomp/rx-stomp": "2.4.0",
    "@stomp/stompjs": "^7.3.0",
    "angular-split": "20.0.0",
    "clipboard": "^2.0.11",
    "core-js": "^3.49.0",
    "cytoscape": "^3.33.2",
    "d3-selection": "3.0.0",
    "echarts": "^6.0.0",
    "geotiff": "3.0.5",
    "marked": "^18.0.0",
    "material-design-icons": "3.0.1",
    "mermaid": "^11.14.0",
    "moment": "2.30.1",
    "moment-timezone": "0.6.3",
    "ngx-color-picker": "20.1.1",
    "ngx-echarts": "^21.0.0",
    "ngx-image-cropper": "^9.1.2",
    "ngx-json-viewer": "3.2.1",
    "ngx-markdown": "^21.1.0",
    "ngx-moment": "6.0.2",
    "ngx-ui-loader": "19.0.0",
    "ol": "^10.9.0",
    "ol-contextmenu": "6.0.1",
    "ol-ext": "4.0.38",
    "rxjs": "7.8.2",
    "tslib": "2.8.1",
    "uuid": "11.1.1",
    "web-animations-js": "2.3.2",
    "write-excel-file": "^4.0.2",
    "xlsx": "file:vendor/xlsx-0.20.3.tgz",
    "zipcelx": "1.6.2",
    "zone.js": "^0.16.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.19",
    "@angular-eslint/builder": "21.4.0",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/schematics": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular/build": "^21.2.19",
    "@angular/cli": "^21.2.19",
    "@angular/compiler-cli": "^21.2.18",
    "@angular/language-service": "^21.2.18",
    "@babel/compat-data": "7.29.7",
    "@compodoc/compodoc": "^1.2.1",
    "@storybook/addon-docs": "^10.2.7",
    "@storybook/addon-onboarding": "^10.2.7",
    "@storybook/addon-themes": "^10.2.7",
    "@storybook/angular": "^10.2.7",
    "@types/jasmine": "6.0.0",
    "@types/jasminewd2": "2.0.13",
    "@types/node": "24.13.3",
    "@typescript-eslint/eslint-plugin": "^8.54.0",
    "@typescript-eslint/parser": "^8.54.0",
    "cross-env": "10.1.0",
    "dotenv-cli": "^11.0.0",
    "eslint": "^9.20.1",
    "eslint-plugin-storybook": "^10.2.7",
    "http-server": "14.1.1",
    "jasmine-core": "6.3.0",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.2.0",
    "ngrx-store-freeze": "0.2.4",
    "prettier": "3.9.6",
    "rimraf": "6.1.3",
    "storybook": "^10.2.7",
    "ts-node": "10.9.2",
    "typescript": "5.9.3",
    "webpack-bundle-analyzer": "^5.3.0"
  },
  "browser": {
    "fs": false,
    "path": false,
    "os": false
  }
}
